export interface SseOptions {
  keepAlive: boolean;

  reconnectionDelay: number;
}

export const defaultSseOptions: SseOptions = { keepAlive: true, reconnectionDelay: 3_000 };
